import React from 'react';

const isClassComponent = (component) => {
    return typeof component === 'function' && !!component.prototype.isReactComponent ? true : false;
};

const isFunctionComponent = (component) => {
    return typeof component === 'function' &&
        String(component).includes('return React.createElement')
        ? true
        : false;
};

export const isReactComponent = (component) => {
    return isClassComponent(component) || isFunctionComponent(component) || isElement(component)
        ? true
        : false;
};

const isElement = (element) => {
    return React.isValidElement(element);
};

const isDOMTypeElement = (element) => {
    return isElement(element) && typeof element.type === 'string';
};

const isCompositeTypeElement = (element) => {
    return isElement(element) && typeof element.type === 'function';
};
